import { useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const DISMISS_KEY = "gac_push_prompt_dismissed";

const isIOS = () => /iPad|iPhone|iPod/i.test(navigator.userAgent)
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

// Popup ajakan aktifkan notifikasi OTW (Android/Desktop saja, bukan iOS).
export const PushOptIn = ({ token }) => {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [publicKey, setPublicKey] = useState(null);

  useEffect(() => {
    if (isIOS() || !supported() || sessionStorage.getItem(DISMISS_KEY) || Notification.permission === "denied") return undefined;
    let t;
    axios.get(`${BASE}/api/push/status/${token}`).then(({ data }) => {
      if (!data.enabled || data.subscribed) return;
      setPublicKey(data.public_key);
      t = setTimeout(() => setShow(true), 6000);
    }).catch(() => {});
    return () => clearTimeout(t);
  }, [token]);

  const close = () => { sessionStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const enable = async () => {
    setBusy(true);
    try {
      if ((await Notification.requestPermission()) !== "granted") return;
      const reg = await navigator.serviceWorker.register("/push-sw.js");
      await navigator.serviceWorker.ready;
      const sub = (await reg.pushManager.getSubscription())
        || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(publicKey) });
      await axios.post(`${BASE}/api/push/subscribe`, { tracking_token: token, subscription: sub.toJSON() });
    } catch { /* izin ditolak / browser tidak mendukung */ } finally { setBusy(false); close(); }
  };

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[2000] bg-black/40 grid place-items-end sm:place-items-center p-4" data-testid="push-optin-overlay">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-5 animate-in slide-in-from-bottom-4 duration-300" data-testid="push-optin-popup">
        <div className="w-11 h-11 rounded-full bg-orange-50 grid place-items-center mb-3">
          <BellRing className="w-5 h-5 text-[#E65100]" />
        </div>
        <p className="text-[15px] leading-snug text-zinc-800 font-medium" data-testid="push-optin-text">
          Ingin dikabari saat teknisi menuju rumah kakak, silahkan aktifkan dan izinkan notifikasinya
        </p>
        <div className="mt-5 flex gap-2">
          <button onClick={close} disabled={busy} data-testid="push-optin-no-btn"
            className="flex-1 h-11 rounded-xl border border-zinc-300 text-zinc-700 text-sm font-semibold hover:bg-zinc-50 transition-colors">
            Tidak perlu
          </button>
          <button onClick={enable} disabled={busy} data-testid="push-optin-yes-btn"
            className="flex-1 h-11 rounded-xl bg-[#E65100] text-white text-sm font-bold hover:bg-[#c94700] transition-colors grid place-items-center">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Ya, aktifkan"}
          </button>
        </div>
      </div>
    </div>
  );
};
